"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsupportedFn = void 0;
function unsupportedFn(fnName) {
    return () => {
        throw new Error(`Unsupported function: ${fnName}`);
    };
}
exports.unsupportedFn = unsupportedFn;
//# sourceMappingURL=unsupported-fn.js.map